import { createSelector } from 'reselect';

const job = (store) => store.apps.job;

const containerSelector = createSelector([
  job,
],
(filteredState) => ({
  loading: filteredState.embeddedContainer.get('loading'),
}));

export default containerSelector;
export {
  containerSelector,
  job,
};
